jQuery(document).ready(function ($) {

    /**
     * Mobile menu toggle
     */
    $('#menuToggle').click(function () {
        //e.preventDefault();
        var $this = $(this);
        $this.toggleClass('active');
        $('.menuFull').slideToggle(300);
        //$('.menuFull').toggleClass('active');
    });


    var add_arrows_to_menus = function () {

        // on load add arrows as appropriate
        jQuery('.menuFull').find('li.menu-item-has-children > a').append('<span class="menu_arrow">></span>');
        // then, change those that should be open to downs.
        jQuery('.menuFull').find('li.current-menu-parent > a .fa, li.current-menu-ancestor > a .fa').removeClass('fa-angle-right').addClass('fa-angle-down');


        $('.menu_arrow').click(function (e) {
            e.preventDefault();
            $(this).closest('li').toggleClass('active');
        });
    }

    add_arrows_to_menus();


    var $body,
        $target,
        resizetimer,
        stickyclass= 'sticky', //class to add to BODY when header should be sticky
        lastpos


    function showHideMenubar(){
        var scrollTop = $(document).scrollTop();
        var goingUp = (scrollTop < lastpos)
        lastpos = scrollTop;
        if (goingUp) {
            $target.removeClass('hidden');
        } else if (scrollTop > 300){
            $target.addClass('hidden');
        } else{
            $target.removeClass('hidden');
        }
    }


    $body = $(document.body)
    $target = $('.pageHeader')
    lastpos = 0
    $(window).on('scroll', function(){
        requestAnimationFrame(showHideMenubar)
    })
    $(window).on('resize', function(){
        clearTimeout(resizetimer)
        resizetimer = setTimeout(function(){
            $body.removeClass(stickyclass)
            showHideMenubar()
        }, 50)
    })

});
